// removed by extract-text-webpack-plugin
module.exports = {"exercisesListItem":"zJbTalcIeC1-rFTllVwcp","exercisesListAddItem":"_2RvGHXvA8S99SmLU-Dr4Bf","execisesListItemDifficulty":"OLWuTxL7qW2vSgmA2ttaj","exercisesListItemTitle":"WupP3pBP-Ve-SZkMB1A1x","exercisesListItemCount":"_3lV9qeWgSjqdUCHJ22_kzw","dragHandle":"_1CAYEDD-TgaSCHfdZsXYz9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MCQQuestionsListItem/MCQQuestionsListItem.scss
// module id = 917
// module chunks = 0